export default "__VITE_ASSET__S8IIeQ8C__"